/**
 * Portal Manta · EstruturasTecnicasPanel
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { M } from '../../tokens/theme.js';
import { V, S, FonteBadge } from '../../globals.js';
import { ESTRUTURAS_TIPOLOGIAS } from '../../data/estruturas-tipologias.js';
import { PavCross } from '../charts/PavCross.jsx';
import { MEFvsMantaTable } from '../charts/MEFvsMantaTable.jsx';
import { OAECross } from '../charts/OAECross.jsx';
import { PassCross } from '../charts/PassCross.jsx';

function EstruturasTecnicasPanel({lote, onFonte}){
  const E = ESTRUTURAS_TIPOLOGIAS;
  const fonteEstr = {doc:'EVTEA + MEF + Especificações Manta', pag:'Cruzamento dos anexos técnicos do edital com referência interna Manta', data:'2025-01-01', aut:'Manta · Engenharia'};
  return (<div style={{padding:'14px 17px',background:V.g0}}>
    <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:6}}>
      <div style={{fontSize:14,fontWeight:700,color:V.br}}>Estruturas Técnicas — comparativo MEF × Manta</div>
      <FonteBadge fonte={fonteEstr} onClick={()=>onFonte({fonte:fonteEstr,label:'Estruturas técnicas — fontes'})}/>
    </div>
    <div style={{fontSize:10.5,color:V.g4,marginBottom:14}}>Para cada tipologia: seção transversal típica e consumo de material por km/m²/un. Coluna MEF reproduz o que o edital especifica; coluna Manta traz alternativa técnica recomendada (otimização de custo, durabilidade ou desempenho).</div>

    {/* PAVIMENTO */}
    <div style={{...S.cardP, padding:'16px 18px', marginBottom:14}}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:12}}>
        <div style={{fontSize:12,fontWeight:700,color:V.or,letterSpacing:.3,textTransform:'uppercase'}}>{E.pavimento.titulo}</div>
        <div style={{fontSize:10,color:V.g4}}>Vida MEF: {E.pavimento.mef.vida} · Vida Manta: <strong style={{color:V.gn}}>{E.pavimento.manta.vida}</strong></div>
      </div>
      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1.4fr',gap:18,alignItems:'start'}}>
        <PavCross camadas={E.pavimento.mef.camadas} label="MEF — edital"/>
        <PavCross camadas={E.pavimento.manta.camadas} label="Manta — recomendado"/>
        <div>
          <div style={{fontSize:11,fontWeight:700,color:V.br,marginBottom:6}}>Consumo por km — pista dupla (7,2 m × 2)</div>
          <MEFvsMantaTable rows={E.pavimento.consumo_km_pista_dupla} unidadeBase="km"/>
          <div style={{marginTop:8,padding:'8px 10px',background:V.gnb,borderRadius:6,fontSize:10,color:'#0F5238'}}>
            <strong>Pleito potencial:</strong> redução de CBUQ revestimento (-11%) + reaproveitamento de solo local pode gerar economia de R$ 80-150 mil/km de duplicação. Em escala de lote (130–238 km), R$ 10–35 M.
          </div>
        </div>
      </div>
    </div>

    {/* OAE */}
    <div style={{...S.cardP, padding:'16px 18px', marginBottom:14}}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:12}}>
        <div style={{fontSize:12,fontWeight:700,color:V.or,letterSpacing:.3,textTransform:'uppercase'}}>{E.oae.titulo}</div>
        <div style={{fontSize:10,color:V.g4}}>Vida MEF: {E.oae.mef.vida} · Vida Manta: <strong style={{color:V.gn}}>{E.oae.manta.vida}</strong></div>
      </div>
      <div style={{display:'grid',gridTemplateColumns:'1fr 1.6fr',gap:18,alignItems:'start'}}>
        <OAECross label="Seção transversal · MEF" vigamento={E.oae.mef.vigamento} fundacao={E.oae.mef.fundacao}/>
        <div>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14,marginBottom:12,fontSize:10.5}}>
            <div style={{padding:'10px 12px',background:V.blb,borderRadius:6,border:'1px solid #C5D7EE'}}>
              <div style={{fontSize:9.5,fontWeight:700,color:V.bl,letterSpacing:.4,textTransform:'uppercase',marginBottom:4}}>MEF</div>
              {Object.entries(E.oae.mef).filter(([k])=>k!=='vida').map(([k,v])=>(
                <div key={k} style={{marginBottom:3}}><strong style={{color:V.g7}}>{k}:</strong> <span style={{color:V.g5}}>{v}</span></div>
              ))}
            </div>
            <div style={{padding:'10px 12px',background:V.orp,borderRadius:6,border:'1px solid '+V.orm}}>
              <div style={{fontSize:9.5,fontWeight:700,color:V.or,letterSpacing:.4,textTransform:'uppercase',marginBottom:4}}>Manta</div>
              {Object.entries(E.oae.manta).filter(([k])=>k!=='vida').map(([k,v])=>(
                <div key={k} style={{marginBottom:3}}><strong style={{color:V.g7}}>{k}:</strong> <span style={{color:V.g5}}>{v}</span></div>
              ))}
            </div>
          </div>
          <div style={{fontSize:11,fontWeight:700,color:V.br,marginBottom:6}}>Consumo por m² de tabuleiro</div>
          <MEFvsMantaTable rows={E.oae.consumo_m2}/>
        </div>
      </div>
    </div>

    {/* PASSARELA */}
    <div style={{...S.cardP, padding:'16px 18px'}}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:12}}>
        <div style={{fontSize:12,fontWeight:700,color:V.or,letterSpacing:.3,textTransform:'uppercase'}}>{E.passarela.titulo}</div>
        <div style={{fontSize:10,color:V.g4}}>Vão típico: {E.passarela.vao_tipico} m · largura {E.passarela.largura} m</div>
      </div>
      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1.6fr',gap:18,alignItems:'start'}}>
        <PassCross label="MEF — edital" estrutura={E.passarela.mef.estrutura} cobertura={false}/>
        <PassCross label="Manta — recomendado" estrutura={E.passarela.manta.estrutura} cobertura={true}/>
        <div>
          <div style={{fontSize:11,fontWeight:700,color:V.br,marginBottom:6}}>Consumo por unidade de passarela</div>
          <MEFvsMantaTable rows={E.passarela.consumo_un}/>
          <div style={{marginTop:8,padding:'8px 10px',background:V.orp,borderRadius:6,fontSize:10,color:V.br2}}>
            <strong>Trade-off:</strong> Manta agrega ~17% no custo unitário (cobertura + acessibilidade + galvanização) com ganho de 15 anos de vida útil + conformidade NBR 9050. Recomendado para travessias de alto fluxo de pedestres.
          </div>
        </div>
      </div>
    </div>
  </div>);
}

export { EstruturasTecnicasPanel };
export default EstruturasTecnicasPanel;
